module.exports = __webpack_public_path__ + "static/media/ai.7d1f3d39.svg";